// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';
import '../node_modules/@glidejs/glide/dist/glide.min';
import '../node_modules/@splidejs/splide/dist/js/splide.min';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';
import './modules/core/module-tabs/module';

// modules
import './modules/evox/shop-all/module';
import './modules/theme/module-hero/module';
import './modules/theme/module-heroboxes/module';
import './modules/theme/module-catboxes/module';
import './modules/theme/why-us/module';
import './modules/theme/login-modal/module';
import './modules/evox/blog-carousel/module';
import './modules/evox/brands-slider/module';
import './modules/theme/services/module';
import './modules/theme/switch-save-modal/module';
import './modules/theme/contact-us-modal/module';
import './modules/theme/banners/module';
import './modules/evox/cat-box/module';

// layouts
import './layouts/dashboard/layout';
import './layouts/pdp/layout';
import './layouts/plp/layout';
import './layouts/category-page/module';
import './layouts/delivery-returns/module';
import './layouts/request-an-account/layout';
import './layouts/pdp-chair-assembly/layout';

// leave me last
import './js/base/base-end';
